module.exports = __webpack_public_path__ + "img/40392323.9575d7b9.png";